<template>
  <div class="oauth-redirect-urls">
    <ElButton
      type="primary"
      icon="el-icon-plus"
      @click.native.prevent="openModal('isRedirectModalOpen')"
    >
      {{ $t('APP.OAUTH.REDIRECT_URLS.NEW_REDIRECT_URL') }}
    </ElButton>

    <OAuthRedirectUrlsList
      :loading="loading"
      :redirect-urls="redirectUrls"
      @delete-redirect-url="deleteRedirectUrl"
    />
    <AddRedirectUrlModal
      v-model="isRedirectModalOpen"
      @redirect-url-add="addRedirectUrl"
    />
  </div>
</template>

<script>
import { OAuth } from '@/api/api';
import modal from '@/mixins/modal';

import packageNameWatch from '@/mixins/apps/packageNameWatch';
import packageName from '@/mixins/packageName';

import AddRedirectUrlModal from './AddRedirectUrlModal';
import OAuthRedirectUrlsList from './OAuthRedirectUrlsList';

export default {
  name: 'OAuthRedirectUrls',

  components: {
    AddRedirectUrlModal,
    OAuthRedirectUrlsList,
  },

  mixins: [modal, packageName, packageNameWatch],

  data() {
    return {
      redirectUrls: [],
      isRedirectModalOpen: false,
      loading: true,
    };
  },

  created() {
    this.getInfo();
  },

  methods: {
    getInfo() {
      this.loading = true;

      return OAuth.getAllRedirectUrls(this.packageName)
        .then(redirectUrls => {
          this.redirectUrls = redirectUrls;
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addRedirectUrl(redirectUrl) {
      this.redirectUrls.unshift(redirectUrl);
    },
    removeRedirectUrlFromList(redirectUrl) {
      const indexOfRedirectUrlToRemove = this.redirectUrls.indexOf(redirectUrl);
      this.redirectUrls.splice(indexOfRedirectUrlToRemove, 1);
    },
    deleteRedirectUrl(redirectUrl) {
      return OAuth.removeRedirectUrl({
        packageName: this.packageName,
        id: redirectUrl.id,
      })
        .then(() => {
          this.$message.success(this.$t('DELETE_COMPLETED'));

          this.removeRedirectUrlFromList(redirectUrl);
        })
        .catch(({ message }) => {
          this.$message.error(message);
        });
    },
  },
};
</script>
